export const WEEKDAYS = [
  [1, "Lunes"], [2, "Martes"], [3, "Miércoles"], [4, "Jueves"],
  [5, "Viernes"], [6, "Sábado"], [7, "Domingo"],
];

export function addDays(day, amount) {
  const date = new Date(`${day}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + amount);
  return date.toISOString().slice(0, 10);
}

export function scheduledDates(desde, hasta, diasSemana) {
  const start = new Date(`${desde}T00:00:00Z`), end = new Date(`${hasta}T00:00:00Z`);
  if (!Number.isFinite(+start) || !Number.isFinite(+end) || end < start ||
    start.toISOString().slice(0, 10) !== desde || end.toISOString().slice(0, 10) !== hasta ||
    (end - start) / 86400000 > 366 * 5) return [];
  const result = [];
  for (let time = +start; time <= +end; time += 86400000) {
    const date = new Date(time);
    if (diasSemana.includes(date.getUTCDay() || 7)) result.push(date.toISOString().slice(0, 10));
  }
  return result;
}

export const displayDate = (day) => String(day).split("-").reverse().join("/");
export const displayWeekdays = (days) => WEEKDAYS.filter(([value]) => days.includes(value)).map(([, label]) => label).join(", ");
